/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import { useMemo } from 'react';
import useConfig from '../hooks/useConfig.js';
import { useLocaleReceiver } from '../locale/LocalReceiver.js';
import '../_chunks/dep-2acfafca.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-46de7b2e.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';

function useTreeConfig() {
  var _useConfig = useConfig(),
    prefix = _useConfig.classPrefix;
  var _useLocaleReceiver = useLocaleReceiver("tree"),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 2),
    _locale = _useLocaleReceiver2[0],
    t = _useLocaleReceiver2[1];
  return useMemo(function () {
    var tree = "".concat(prefix, "-tree");
    var treeClassNames = {
      icon: "".concat(prefix, "-icon"),
      folderIcon: "".concat(prefix, "-folder-icon"),
      actived: "".concat(prefix, "-is-active"),
      disabled: "".concat(prefix, "-is-disabled"),
      treeIconRight: "".concat(prefix, "-icon-arrow-right"),
      treeIconDown: "".concat(prefix, "-icon-arrow-down"),
      tree: tree,
      treeFx: "".concat(tree, "--transition"),
      treeBlockNode: "".concat(tree, "--block-node"),
      treeEmpty: "".concat(tree, "__empty"),
      treeList: "".concat(tree, "__list"),
      treeNode: "".concat(tree, "__item"),
      treeNodeOpen: "".concat(tree, "__item--open"),
      treeHoverable: "".concat(tree, "--hoverable"),
      treeCheckable: "".concat(tree, "--checkable"),
      treeLabel: "".concat(tree, "__label"),
      treeLabelStrictly: "".concat(tree, "__label--strictly"),
      treeIcon: "".concat(tree, "__icon"),
      treeIconDefault: "".concat(tree, "__icon--default"),
      treeSpace: "".concat(tree, "__space"),
      treeOperations: "".concat(tree, "__operations"),
      treeNodeDraggable: "".concat(tree, "__item--draggable"),
      treeNodeDragging: "".concat(tree, "__item--dragging"),
      treeNodeDragTipTop: "".concat(tree, "__item--tip-top"),
      treeNodeDragTipBottom: "".concat(tree, "__item--tip-bottom"),
      treeNodeDragTipHighlight: "".concat(tree, "__item--tip-highlight"),
      line: "".concat(tree, "__line"),
      lineIsLeaf: "".concat(tree, "__line--leaf"),
      lineIsFirst: "".concat(tree, "__line--first"),
      treeNodeShow: "".concat(tree, "__item--show"),
      treeClickable: "".concat(tree, "__item--clickable"),
      loading: "".concat(prefix, "-icon-loading ").concat(prefix, "-icon-loading-blue"),
      toggleEnter: "".concat(tree, "__item--enter-active"),
      toggleLeave: "".concat(tree, "__item--leave-active")
    };
    var transitionNames = {
      treeNode: "".concat(prefix, "-tree-toggle")
    };
    var transitionClassNames = {
      enter: treeClassNames.toggleEnter,
      exit: treeClassNames.toggleLeave
    };
    return {
      treeClassNames: treeClassNames,
      transitionNames: transitionNames,
      transitionClassNames: transitionClassNames,
      transitionDuration: 300,
      locale: function locale(key) {
        return t(_locale[key]);
      }
    };
  }, [_locale, prefix, t]);
}

export { useTreeConfig };
//# sourceMappingURL=useTreeConfig.js.map
